module.exports = __webpack_public_path__ + "header-profile-skin-1.85efa900c0fc12fee15a.png";


//////////////////
// WEBPACK FOOTER
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/assets/styles/patterns/header-profile-skin-1.png
// module id = ../../../../../src/assets/styles/patterns/header-profile-skin-1.png
// module chunks = styles